import { gql } from '__generated__';

export default gql(`
  query GetTranslation($project_id: ID!, $source: Locale!, $target: Locale!, $content: String!, $has_html: Boolean!) {
    project(id: $project_id) {
      id
      translation(source: $source, target: $target, content: $content, has_html: $has_html)
    }
  }
`);
